// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_18_1-map {
  /* Typography */
  --perxis-auto-map-cluster-font-family-inner: var(
    --perxis-auto-map-cluster-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-map-cluster-font-size-inner: var(--perxis-auto-map-cluster-font-size, 20px);
  --perxis-auto-map-cluster-font-weight-inner: var(--perxis-auto-map-cluster-font-weight, 600);
  --perxis-auto-map-cluster-letter-spacing-inner: var(--perxis-auto-map-cluster-letter-spacing, 0em);
  --perxis-auto-map-cluster-line-height-inner: var(--perxis-auto-map-cluster-line-height, 1);
  --perxis-auto-map-cluster-text-transform-inner: var(--perxis-auto-map-cluster-text-transform, none);
  --perxis-auto-map-cluster-color-inner: var(
    --perxis-auto-map-cluster-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  --perxis-auto-map-cluster-hover-color-inner: var(
    --perxis-auto-map-cluster-hover-color,
    var(--perxis-auto-root-typography-color-lightest-inner)
  );
  --perxis-auto-map-balloon-font-family-inner: var(
    --perxis-auto-map-balloon-font-family,
    var(--perxis-auto-root-typography-main-font-family-inner)
  );
  --perxis-auto-map-balloon-font-size-inner: var(
    --perxis-auto-map-balloon-font-size,
    var(--perxis-auto-root-typography-main-font-size-xxl-inner)
  );
  --perxis-auto-map-balloon-font-weight-inner: var(
    --perxis-auto-map-balloon-font-weight,
    var(--perxis-auto-root-typography-main-font-weight-inner)
  );
  --perxis-auto-map-balloon-letter-spacing-inner: var(
    --perxis-auto-map-balloon-letter-spacing,
    var(--perxis-auto-root-typography-main-letter-spacing-inner)
  );
  --perxis-auto-map-balloon-line-height-inner: var(
    --perxis-auto-map-balloon-line-height,
    var(--perxis-auto-root-typography-main-line-height-xxl-inner)
  );
  --perxis-auto-map-balloon-text-transform-inner: var(
    --perxis-auto-map-balloon-text-transform,
    var(--perxis-auto-root-typography-main-text-transform-inner)
  );
  --perxis-auto-map-balloon-color-inner: var(
    --perxis-auto-map-balloon-color,
    var(--perxis-auto-root-typography-color-darkest-inner)
  );
  /* End Typography */
  /* Colors */
  --perxis-auto-map-skeleton-background-color-inner: var(
    --perxis-auto-map-skeleton-background-color,
    var(--perxis-auto-root-sixth-color-inner)
  );
  --perxis-auto-map-balloon-background-color-inner: var(
    --perxis-auto-map-balloon-background-color,
    var(--perxis-auto-root-first-color-inner)
  );
  --perxis-auto-map-balloon-border-color-inner: var(
    --perxis-auto-map-balloon-border-color,
    var(--perxis-auto-root-first-color-inner)
  );
  /* End Colors */
  /* Border */
  --perxis-auto-map-balloon-border-radius-inner: var(--perxis-auto-map-balloon-border-radius, 16px);
  --perxis-auto-map-balloon-border-width-inner: var(--perxis-auto-map-balloon-border-width, 0px);
  /* End Border */
  /* Padding */
  --perxis-auto-map-balloon-padding-inner: var(
    --perxis-auto-map-balloon-padding,
    var(--perxis-auto-gap-vertical-sky-inner) 18px
  );
  /* End Padding */
  /* Box Shadow */
  --perxis-auto-map-balloon-box-shadow-inner: var(
    --perxis-auto-map-balloon-box-shadow,
    0px 0px 10px rgba(38, 38, 38, 0.2)
  );
  /* End Box Shadow */
  position: relative;
  height: 100%;
  width: 100%;
}
.perxis-auto-1_18_1-map__skeleton.ant-5_24_1-skeleton,
.perxis-auto-1_18_1-map__skeleton.ant-5_24_1-skeleton .ant-5_24_1-skeleton-image {
  height: 100%;
  width: 100%;
  background: var(--perxis-auto-map-skeleton-background-color-inner);
}
.perxis-auto-1_18_1-map__cluster {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: auto;
  transform: translate(-50%, -50%);
  font-family: var(--perxis-auto-map-cluster-font-family-inner) !important;
  font-size: var(--perxis-auto-map-cluster-font-size-inner) !important;
  line-height: var(--perxis-auto-map-cluster-line-height-inner);
  font-weight: var(--perxis-auto-map-cluster-font-weight-inner);
  text-transform: var(--perxis-auto-map-cluster-text-transform-inner);
  letter-spacing: var(--perxis-auto-map-cluster-letter-spacing-inner);
  color: var(--perxis-auto-map-cluster-color-inner) !important;
}
.perxis-auto-1_18_1-map__cluster-image {
  width: 100%;
  height: 100%;
}
.perxis-auto-1_18_1-map__cluster-hover {
  color: var(--perxis-auto-map-cluster-hover-color-inner) !important;
}
.perxis-auto-1_18_1-map__balloon, .perxis-auto-1_18_1-map__hint {
  display: flex;
  flex-direction: column;
  font-family: var(--perxis-auto-map-balloon-font-family-inner);
  font-size: var(--perxis-auto-map-balloon-font-size-inner);
  line-height: var(--perxis-auto-map-balloon-line-height-inner);
  font-weight: var(--perxis-auto-map-balloon-font-weight-inner);
  text-transform: var(--perxis-auto-map-balloon-text-transform-inner);
  letter-spacing: var(--perxis-auto-map-balloon-letter-spacing-inner);
  color: var(--perxis-auto-map-balloon-color-inner);
  background-color: var(--perxis-auto-map-balloon-background-color-inner);
  border: var(--perxis-auto-map-balloon-border-width-inner) solid var(--perxis-auto-map-balloon-border-color-inner);
  box-shadow: var(--perxis-auto-map-balloon-box-shadow-inner);
  padding: var(--perxis-auto-map-balloon-padding-inner);
  border-radius: var(--perxis-auto-map-balloon-border-radius-inner);
  width: 320px;
}
@media (max-width: 576px) {
  .perxis-auto-1_18_1-map__balloon, .perxis-auto-1_18_1-map__hint {
    width: 280px;
  }
}
.perxis-auto-1_18_1-map__balloon:empty, .perxis-auto-1_18_1-map__hint:empty {
  display: none;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon__layout {
  background: transparent;
  overflow: initial;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon,
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-hint {
  box-shadow: none;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon__close {
  display: none;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon__content {
  padding: 0;
  margin: 0;
  background: transparent;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon__content > * {
  overflow: initial !important;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-balloon__tail {
  display: none;
}
.perxis-auto-1_18_1-map .ymaps-2-1-79-map .ymaps-2-1-79-hint__text {
  background: transparent;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
